import { memo } from 'react';
import { Main } from './main/Loadable';

import InfoModal from './main/InfoModal';
const Derivatives = memo(() => {
    return (
        <>
            <Main />
            <InfoModal />
        </>
    )
})

export default Derivatives
